<template>
  <div class="page-view videos">
    <template v-if="t.photosMenu">
      <div class="side-menu">
        <div v-if="width<760" class="burger-menu-wrap">
          <span
            @click="open=!open"
            :class="{
              'burger-menu': true,
              'diginity':true,
              'dg-list':!open,
              'dg-close':open
            }"
          ></span>
        </div>
        <ul
          v-if="t.photosMenu"
          :class="{
            'menu-list':true,
            'hamburger':width<760,
            'open':open
          }"
        >
          <li
            v-for="(p,i) in t.photosMenu"
            :key="i"
            :class="{
              'menu-btn':true,
              'active':true
            }"
          >
            <router-link
              :to="`/${lng}/photo_galleries/${p.position}`"
              active-class="active"
              exact
            >{{ p.key }}</router-link>
          </li>
        </ul>
      </div>
      <template v-if="Array.isArray(photos_list)&&photos_list.length">
        <!-- See child component 'views/photos/' -->
        <router-view/>
      </template>
      <!-- loading animation template -->
      <template v-else>
        <div class="spinner" v-if="Array.isArray(photos_list) && !photos_list.length">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
        <p class="response-error" v-if="photos_list==undefined">
          <span>{{ lng == 'tr' ? 'Kayıt bulunamadı' : 'No Records Found' }}</span>
        </p>
      </template>
    </template>
    <template v-else>
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      width: window.innerWidth,
      open: false
    };
  },
  computed: {
    ...mapGetters(["t", "lng", "photos_list"])
  },
  beforeMount() {
    var self = this;
    // get windowWidth for photos menu inside dropdown responsive
    self.$nextTick(() => {
      window.addEventListener("resize", () => {
        self.width = window.innerWidth;
      });
    });
  },
  created() {
    // 'store_modules/Actions.js' see => 'photos_list'
    this.$store.dispatch("photos_list");
    this.$scrollTo("body", this.$store.state.scrollSpeed);
  }
};
</script>


<style lang="scss" scoped>
@import "../styles/colors";
.page-view {
  background: #e7e7e7;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }

  /*  CONTENT */
  .content {
    flex: 1;
    position: relative;
    padding: 10px 20px;
    @media screen and (max-width: 760px) {
      flex: 1 auto;
    }
  }
}
.videos {
  .side-menu {
    min-width: 260px;
    padding: 30px 5px 10px;
    @media screen and (max-width: 760px) {
      padding: 10px 5px;
    }
    ul.menu-list {
      padding-left: 20px;
      &.hamburger {
        display: none;
        &.open {
          display: flex !important;
        }
      }
      // mobile menu
      @media screen and (max-width: 760px) {
        padding: 0;
        display: flex;
        flex-wrap: wrap;
      }
      li.menu-btn {
        margin: 5px;
        & > a {
          color: #8a8b8d;
          text-align: left;
          padding: 7px;
          font-size: 14px;
          display: block;
          &.active {
            color: $main;
            &:hover:not(.non_route) {
              color: $main;
            }
          }
          &:hover:not(.non_route) {
            color: #606266;
          }
        }
        &.active {
          ul.dropdown {
            display: block;
            padding-left: 20px;
          }
        }
        ul.dropdown {
          padding: 5px 0;
          display: none;
          li {
            a {
              color: #8a8b8d;
              display: block;
              font-size: 14px;
              padding: 5px 8px;
              font-weight: 500;
              &:hover {
                color: #606266;
              }
              &.active {
                color: $main !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
